import React               from 'react'
import useProductPrices    from './useProductPrices'
import { Spinner }         from '@components/Spinner/Spinner'
import ProductPriceRow     from './ProductPriceRow'
import NewProductPriceForm from './NewProductPriceForm'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export default function ProductPriceManager({ filter, page, dataPath }) {
  const clientId = filter.client.id
  const {
    prices, loading,

    // add
    isAdding, template,
    startAdd, cancelAdd,
    loadTemplate, create,

    // edit
    editingId, editValue, editDiscount,
    startEdit, cancelEdit,
    setEditValue, setEditDiscount, update,

    // delete
    remove,
  } = useProductPrices({
    clientId,
    page,
    dataPath,
    filterProducts: filter.product || []
  })


  if (loading) return <Spinner />

  return (
    <div className="css-grid-container product-prices-grid">
      <div className="css-grid" style={{ gridTemplateColumns: '1.5fr 2fr 0.6fr 1fr 1fr 1fr 0.8fr 0.5fr' }}>

        {/* header */}
        <div className="header">
          <div className="text-left">{I18n.t("product_prices.reference")}</div>
          <div className="text-left">{I18n.t("product_prices.description")}</div>
          <div>{I18n.t("product_prices.unit")}</div>
          <div>{I18n.t("product_prices.price_purchase")}</div>
          <div>{I18n.t("product_prices.price_regular")}</div>
          <div>{I18n.t("product_prices.price_client")}</div>
          <div>{I18n.t("product_prices.discount")}</div>
          <div></div>
        </div>

        <div className="main">
          {isAdding ? (
            <div className="row">
              <NewProductPriceForm
                template       = {template}
                onProductSelect= {loadTemplate}
                onSubmit       = {create}
                onCancel       = {cancelAdd}
              />
            </div>
          ) : (
            <div className="pl-2 add_button" onClick={startAdd}>
              <FontAwesomeIcon icon="plus-circle" /> &nbsp;
              {I18n.t("product_prices.add_new")}
            </div>
          )}

          {prices.map(p => (
            <ProductPriceRow
              key              = {p.id}
              productPrice     = {p}
              isEditing        = {editingId === p.id}
              editValue        = {editingId === p.id ? editValue : undefined}
              editDiscount     = {editingId === p.id ? editDiscount : undefined}
              onStartEdit      = {() => startEdit(p)}
              onEditChange     = {setEditValue}
              onDiscountChange = {setEditDiscount}
              onCancelEdit     = {cancelEdit}
              onSaveEdit       = {update}
              onDelete         = {() => remove(p.id)}
            />
          ))}
        </div>
      </div>
    </div>
  )
}
